export function useAskAiModal() {
  const isOpen = useState<boolean>('askAi:open', () => false)
  const open = () => { isOpen.value = true }
  const close = () => { isOpen.value = false }
  const toggle = () => { isOpen.value = !isOpen.value }
  return { isOpen, open, close, toggle }
}
